import React, { useEffect, useState } from "react";
import "../FaqTab/FaqTab.scss";
import {
  createFaq,
  deleteFaq,
  getAllFaq,
  updateFaq,
} from "../../../api/helpCenter";
import { SelectBox } from "devextreme-react";
import { getCustomer } from "../../../api/companyCustomerApi";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";

export default function FaqTab() {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [faqList, setFaqList] = useState([]);
  const [visibility, setVisibility] = useState("public");
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchFaqList();
    fetchCustomers();
  }, []);

  //fetch customer for selecting customer in dropdown
  const fetchCustomers = async () => {
    try {
      const result = await getCustomer();

      if (result?.data?.data) {
        setCustomers(result.data.data);
        return result.data.data;
      }
    } catch (error) {
      console.error("Failed to fetch customers:", error);
    }
  };

  const handleVisibilityChange = (value) => {
    setVisibility(value);

    if (value === "private") {
      fetchCustomers();
    } else {
      setSelectedCustomer(null); // clear dropdown when switching to public
    }
  };

  //To fetxh all the faq for admin
  const fetchFaqList = async () => {
    try {
      // console.log("Fetching FAQs...");

      const result = await getAllFaq();

      // console.log("FAQ Fetch Response:", result);

      if (result?.data) {
        const formattedFaqs = result.data
          .map((faq) => ({
            id: faq.transid,
            question: faq.question,
            answer: faq.answer,
            visibility: faq.filter_type,
            customer_name: faq.customer_name,
          }))
          .reverse();

        setFaqList(formattedFaqs);
      }
    } catch (error) {
      console.error("Failed to fetch FAQs:", error);
    }
  };

  // const handleAddFaq = async () => {
  //   if (!question.trim() || !answer.trim()) return;

  //   const payload = {
  //     question: question,
  //     answer: answer,
  //     filter_type: visibility,
  //     customertransid: visibility === "private" ? selectedCustomer : null,
  //   };

  //   if (visibility === "private" && !selectedCustomer) {
  //     ToastDisplayer("error", "Please select a customer");
  //     return;
  //   }

  //   console.log("Creating FAQ with payload:", payload);

  //   try {
  //     setLoading(true);
  //     const result = await createFaq(payload);
  //     console.log("API Response:", result);

  //     setLoading(false);

  //     if (result?.data) {
  //       console.log("FAQ created successfully:", result.data);
  //       const newFaq = {
  //         id: result.data.transid,
  //         question: result.data.question,
  //         answer: result.data.answer,
  //       };

  //       setFaqList((prev) => [newFaq, ...prev]);

  //       setQuestion("");
  //       setAnswer("");
  //     }
  //   } catch (error) {
  //     console.error("Failed to create FAQ:", error);
  //   }
  // };
  const handleAddFaq = async () => {
    if (!question.trim() || !answer.trim()) return;

    const payload = {
      question,
      answer,
      filter_type: visibility,
      customertransid: visibility === "private" ? selectedCustomer : null,
    };

    if (visibility === "private" && !selectedCustomer) {
      ToastDisplayer("error", "Please select a customer");
      return;
    }

    try {
      setLoading(true);

      if (editingId) {
        // UPDATE FAQ
        await updateFaq(editingId, payload);

        const updatedList = faqList.map((faq) =>
          faq.id === editingId ? { ...faq, question, answer } : faq,
        );

        setFaqList(updatedList);

        ToastDisplayer("success", "FAQ updated successfully");

        setEditingId(null);
      } else {
        // CREATE FAQ
        const result = await createFaq(payload);

        if (result?.data) {
          const newFaq = {
            id: result.data.transid,
            question: result.data.question,
            answer: result.data.answer,
          };

          setFaqList((prev) => [newFaq, ...prev]);
        }
      }

      setQuestion("");
      setAnswer("");
      setSelectedCustomer(null);
      setVisibility("public");
    } catch (error) {
      console.error("Failed:", error);
      ToastDisplayer("error", "Something went wrong");
    }

    setLoading(false);
  };

  const handleEditClick = async (faq) => {
    setEditingId(faq.id);
    setQuestion(faq.question);
    setAnswer(faq.answer);

    setVisibility(faq.visibility || "public");

    if (faq.visibility === "private") {
      const matchedCustomer = customers.find(
        (c) => c.custname === faq.customer_name,
      );

      if (matchedCustomer) {
        setSelectedCustomer(matchedCustomer.transid);
      }
    } else {
      setSelectedCustomer(null);
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleDeleteFaq = async (faqId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this FAQ?",
    );

    if (!confirmDelete) return;

    try {
      await deleteFaq(faqId);

      setFaqList((prev) => prev.filter((faq) => faq.id !== faqId));

      ToastDisplayer("success", "FAQ deleted successfully");
    } catch (error) {
      console.error("Delete failed:", error);
      ToastDisplayer("error", "Failed to delete FAQ");
    }
  };

  return (
    <div className="faqTabSec">
      <div className="faqCardHead">
        <span className="faqCardTitle">Manage Frequently Asked Question</span>
      </div>
      <div className="faqCard"style={{height: "calc(100vh - 348px)" }} >
        {/* Inputs */}
        <div className="faqCardBody">
          {/* Question */}
          <div className="faqListHeader">
            <span>Add Question</span>
          </div>
          <div className="faqInputRow">
            <div className="faqInputWrap">
              <label className="faqLabel">
                Question <span className="faqRequired">*</span>
              </label>
              <input
                className="faqTextBox"
                placeholder="Enter FAQ question"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
            </div>
          </div>

          {/* Answer */}
          <div className="faqInputRow">
            <div className="faqInputWrap">
              <label className="faqLabel">
                Answer <span className="faqRequired">*</span>
              </label>
              <textarea
                className="faqTextBox faqTextarea"
                placeholder="Enter FAQ answer"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
              />
            </div>
          </div>
          {/* Radio + Button Row */}
          <div className="faqActionRow">
            <div className="faqRadioGroup">
              <label>
                <input
                  type="radio"
                  name="visibility"
                  value="public"
                  checked={visibility === "public"}
                  onChange={(e) => handleVisibilityChange(e.target.value)}
                />
                Public
              </label>

              <label>
                <input
                  type="radio"
                  name="visibility"
                  value="private"
                  checked={visibility === "private"}
                  onChange={(e) => handleVisibilityChange(e.target.value)}
                />
                Private
              </label>
            </div>

            <div
              className="faqInputRow faqCustomerDropdown"
              style={{
                visibility: visibility === "private" ? "visible" : "hidden",
              }}
            >
              <div className="">
                <SelectBox
                  height={40}
                  width={220}
                  label="Select Customer"
                  dataSource={customers}
                  stylingMode="outlined"
                  valueExpr="transid"
                  displayExpr="custname"
                  placeholder=""
                  searchEnabled={true}
                  value={selectedCustomer}
                  onValueChanged={(e) => setSelectedCustomer(e.value)}
                  className="faqTextBox"
                />
              </div>
            </div>

            <button
              className="faqAddBtn"
              onClick={handleAddFaq}
              disabled={loading}
            >
              {loading
                ? editingId
                  ? "Updating..."
                  : "Adding..."
                : editingId
                  ? "Update FAQ"
                  : "Add FAQ"}
            </button>
          </div>
        </div>

        {/* FAQ List */}
        <div className="faqListWrap">
          <div className="faqListHeader">
            <span>Question</span>
          </div>

          {faqList.length === 0 && (
            <div className="faqEmptyMsg">No FAQs found.</div>
          )}

          {faqList.map((faq) => (
            <div className="faqListRow" key={faq.id}>
              <div>
                <span className="faqRowQuestion">{faq.question}</span>
                <div className="faqRowAnswer">{faq.answer}</div>
              </div>

              <div className="faqRowActions">
                <button
                  className="faqIconBtn faqEditIcon"
                  onClick={() => handleEditClick(faq)}
                >
                  <i className="ri-pencil-line" />
                </button>

                <button
                  className="faqIconBtn faqDeleteIcon"
                  onClick={() => handleDeleteFaq(faq.id)}
                >
                  <i className="ri-delete-bin-line" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
